import Vue from 'vue';
import {Formatter} from './../services/formatter.service';
import i18n from "../../shared/i18n";
import i18nHelper from "./../../core/services/i18n.service";
import {store} from './../../plugins/vuex/index'

/**
 * @author Saiat Kalbiev <kalbievich11@gmail.com>
 */
Vue.filter('currentDate', function (value, format = null) {
  return Formatter.getCurrentDate(format)
});

/**
 * @author Saiat Kalbiev <kalbievich11@gmail.com>
 */
Vue.filter('toDate', function (value, format) {
  if (!value) return '';
  return Formatter.toDate(value, format)
});

/**
 * @author Saiat Kalbiev <kalbievich11@gmail.com>
 */
Vue.filter('toDateTime', function (value, format) {
  if (!value) return '';
  return Formatter.toDateTime(value, format)
});

/**
 * @author Saiat Kalbiev <kalbievich11@gmail.com>
 */
Vue.filter('toCommaCase', function (value) {
  let data = value.filter(val => val && val !== '');
  return data.join(', ');
});

/**
 * @author Saiat Kalbiev <kalbievich11@gmail.com>
 */
Vue.filter('toUnderScoreCase', function (value) {
  if (!value) return '';
  return value.replace(/\s/g, '_');
});

/**
 * @author Saiat Kalbiev <kalbievich11@gmail.com>
 */
Vue.filter('bytesToSize', function (value) {
  let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (value === 0) {
    return '0 Byte';
  }
  let i = parseInt(Math.floor(Math.log(value) / Math.log(1024)));
  return Math.round(value / Math.pow(1024, i), 2) + ' ' + sizes[i];
});

/**
 * @author Saiat Kalbiev <kalbievich11@gmail.com>
 */
Vue.filter('toLowerCase', function (value) {
  if (!value) return '';
  return value.toLowerCase();
});

/**
 * @author Saiat Kalbiev <kalbievich11@gmail.com>
 */
Vue.filter('removeUnderscores', function (value) {
  return Formatter.removeUnderscores(value)
});

/**
 * @author Saiat Kalbiev <kalbievich11@gmail.com>
 */
Vue.filter('asCurrency', function (value, currency) {
  if (!['number', 'string'].includes(typeof value)) return '';
  return Formatter.asCurrency(value, currency)
});

/**
 * @author Saiat Kalbiev <kalbievich11@gmail.com>
 */
Vue.filter('asPercentage', function (value) {
  return Formatter.asPercentage(value)
});

/**
 * @author Saiat Kalbiev <kalbievich11@gmail.com>
 */
Vue.filter('asAddress', function (address, multiline = true) {
  const data = [address.city, address.country ? address.country.name : '', address.zip_code].filter(val => val && val !== '');
  return `${address.address_1}${multiline ? '' : ','} ${multiline ? "<br>" : ''} ${data.join(', ')}`;
});

/**
 * @author Saiat Kalbiev <kalbievich11@gmail.com>
 */
Vue.filter('splitAddressForMultiline', function (address, index = 2) {
  const position = address.split(",", index).join(",").length;
  return address.substr(0, position) + '<br>' + address.substr(position + 2);
});

/**
 * @author Saiat Kalbiev <kalbievich11@gmail.com>
 */
Vue.filter('toDashedCase', function (value) {
  if (!value) return '';
  return value.replace(/\s/g, '-');
});

/**
 * @author Saiat Kalbiev <kalbievich11@gmail.com>
 */
Vue.filter('toUpperCaseFirst', function (value) {
  return Formatter.toUpperCaseFirst(value);
});

/**
 * @author Saiat Kalbiev <kalbievich11@gmail.com>
 */
Vue.filter('toUpperCaseFirstSentence', function (value) {
  if (!value) return ''
  return value.split(/ /g).map(word => `${word.substring(0, 1).toUpperCase()}${word.substring(1)}`).join(" ");
});

/**
 * @author Saiat Kalbiev <kalbievich11@gmail.com>
 */
Vue.filter('masterLanguage', function (value) {
  return Formatter.getByMasterLanguage(value)
});

/**
 * @author Saiat Kalbiev <kalbievich11@gmail.com>
 */
Vue.filter('attributeByMasterLanguage', function (value, attr) {
  return Formatter.attributeByMasterLanguage(value, attr);
});

/**
 * @author Saiat Kalbiev <kalbievich11@gmail.com>
 */
Vue.filter('truncate', function (value, length) {
  return Formatter.truncate(value, length)
});

/**
 * @author Saiat Kalbiev <kalbievich11@gmail.com>
 */
Vue.filter('round', function (value, decimalPlaces = 2) {
  return parseFloat(value).toFixed(decimalPlaces);
});


/**
 * @author Saiat Kalbiev <kalbievich11@gmail.com>
 */
Vue.filter('randomString', function (value, length = 32) {
  let text = "";
  let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  for (let i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
});

/*
* @author Saiat Kalbiev <kalbievich11@gmail.com>
*/
Vue.filter('striptags', function (value) {
  return Formatter.stripTags(value)
});


/**
 * @author Saiat Kalbiev <kalbievich11@gmail.com>
 */
Vue.filter('asCurrencyByCode', function (value, currencyCode) {
  if (typeof value !== 'number') return '';
  return Formatter.asCurrencyByCode(value, currencyCode)
});


Vue.filter('asBadgeBoolean', function (value) {
  const className = value ? 'badge bg-success text-white' : 'badge bg-danger text-white'
  const val = value ? i18n.t('Yes') : i18n.t('No')

  return '<span class="' + className + '">' + val + '</span>'
});


Vue.filter('asDynamicField', function (value, type, choices, rawData = false) {
  if (type === 'checkbox') {
    return rawData ? value : this.asBadgeBoolean(value)
  }

  if (type === 'number' && value) {
    return rawData ? value : Formatter.getParsedNumber(value);
  }

  if (type === 'ckeditor') {
    return this.striptags(value);
  }

  let processValueForSelect2 = (innerVal) => {
    const selectedOption = choices.find(c => c.value === innerVal)
    if (selectedOption) {
      let masterLang = i18nHelper.getMasterLanguage()
      if (typeof selectedOption.key === 'object' && selectedOption.key[masterLang.key]) {
        return selectedOption.key[masterLang.key]
      }
      return selectedOption.key
    }
    return ''
  }

  if (type === 'select2') {
    if (value && typeof value === 'object' && value.length && value.length > 0) {
      let returnData = []
      value.forEach(tmp => returnData.push(processValueForSelect2(tmp)))
      return returnData.join(', ')
    } else {
      return processValueForSelect2(value)
    }
  }

  if (type === 'tags') {
    if (typeof value === 'object' && value.length && value.length > 0) {
      let returnData = []
      value.forEach(tmp => returnData.push(tmp))
      return returnData.join(', ')
    }
  }

  return value;
});


Vue.filter('toUpperCaseEveryWord', function (value) {
  return Formatter.toUpperCaseEveryWord(value)
});


Vue.filter('asNegativeNumber', function (value) {
  if (!value || typeof value !== 'number') {
    return;
  }
  return -Math.abs(value);
});


Vue.filter('countryNameByCode', function (value) {
  if (!value) {
    return;
  }

  const val = Formatter.getCountryByCode(value)

  return val ? val.name : ''
});

Vue.filter('proposalStatusSuggestionMap', function (value) {
  const valuesMap = {
    reoffer: "Reoffer in a new auction",
    return: "Return to the Seller",
    transfer: "Transfer to 3rd party",
    seller_confirmed: "Seller Confirmed",
    draft: "Draft",
    suggestion_not_sent: "Suggestion Not Sent",
    waiting: "Waiting for Seller Confirmation"
  }
  return valuesMap[value] || ''
});


Vue.filter('asPaymentMethod', function (value) {
  if (!store || !store.state || !value) {
    return value;
  }

  if (store.state.global.paymentMethodsMap[value]) {
    return store.state.global.paymentMethodsMap[value]
  }

  return Formatter.removeUnderscores(Formatter.toUpperCaseEveryWord(value))

});

Vue.filter('asTaxStatus', function (value) {
  if (!store || !store.state || !value) {
    return value;
  }

  const taxStatus = store.state.global.taxStatuses.find(t => t.uuid === value)

  return taxStatus ? taxStatus.name : ''
});


Vue.filter('translate', function (value) {
  return i18n.t(value)
});



/**
 * @author Saiat Kalbiev <kalbievich11@gmail.com>
 */
Vue.filter('calculateTaxRate', function (taxAmount, baseAmount) {
  if (taxAmount <= 0) return 0;
  if (baseAmount <= 0) return 0;

  const taxRate = (taxAmount / baseAmount) * 100;

  if (Number.isInteger(taxRate)) {
    return taxRate;
  }

  return Number(taxRate.toFixed(2));
});
